import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store';
import './registerServiceWorker';
import { ApmVuePlugin } from './libraries/apm';

createApp(App).use(ApmVuePlugin).use(store).use(router).mount('#app');
